<script setup lang="ts">
usePageSeo('seoCamerasTitle', 'seoCamerasDescription');
</script>

<template>
  <div class="cameras-page">
    <Hero
      :title="$t('liveWebCams')"
      :subtitle="$t('camerasSubtitle')"
      backgroundImage="https://res.cloudinary.com/dlct0dnwt/image/upload/v1743292001/refuge/2025/3PMA7282_frwz4z.jpg"
    />

    <div class="content-container">
      <div class="page-header">
        <h2 class="section-title">{{ $t('wonderfulViews') }}</h2>
        <p class="section-subtitle">{{ $t('webCamInfo') }}</p>
      </div>

      <MeteoCamera />
    </div>
  </div>
</template>

<style scoped lang="sass">
.cameras-page
  width: 100vw

.content-container
  max-width: 1300px
  margin: 0 auto
  padding: 4rem 2.5rem 8rem

.page-header
  margin-bottom: 3rem

.section-title
  font-size: 2rem
  font-weight: 800
  margin: 0 0 0.5rem
  letter-spacing: -0.5px

.section-subtitle
  font-size: 1rem
  opacity: 0.55
  font-weight: 500
  margin: 0

@media (max-width: 768px)
  .section-title
    font-size: 1.6rem
</style>
